import { httpClient } from "./http-client";
import { NEW_API_ENDPOINTS } from "../../shared/constants/api";
import type {
  ApiResponseLandingUserInfoResponse,
  UpdateUserInfoRequest,
} from "../../shared/types/api";

export class UserApiService {
  async getUserInfo(): Promise<ApiResponseLandingUserInfoResponse> {
    const response = await httpClient.get<ApiResponseLandingUserInfoResponse>(
      NEW_API_ENDPOINTS.userController.GET,
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "업체 어드민 정보를 가져오지 못했습니다.",
      );
    }

    return response.data;
  }
  async updateUserInfo(
    request: UpdateUserInfoRequest,
  ): Promise<ApiResponseLandingUserInfoResponse> {
    const response = await httpClient.put<ApiResponseLandingUserInfoResponse>(
      NEW_API_ENDPOINTS.userController.PUT,
      request,
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "업체 어드민 정보를 수정하지 못했습니다.",
      );
    }

    return response.data;
  }
}

export const userApiService = new UserApiService();
